/**
 * Whitelist utilities for access control
 */

/**
 * Check if a wallet address is whitelisted to create markets
 */
export function isWhitelistedCreator(address: string | undefined): boolean {
  if (!address) return false;
  
  const whitelist = import.meta.env.VITE_CREATOR_WHITELIST || '';
  
  if (!whitelist) {
    // If no whitelist is set, allow everyone (for development)
    console.warn('⚠️ No creator whitelist configured. All users can create markets.');
    return true;
  }
  
  // Split by comma and clean up addresses
  const whitelistedAddresses = whitelist
    .split(',')
    .map((addr: string) => addr.trim().toLowerCase())
    .filter((addr: string) => addr.length > 0);
  
  return whitelistedAddresses.includes(address.toLowerCase());
}

